import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { extractedImages } from './documentProcessor';
import './MessageContent.css';

// Create a simpler code renderer without the syntax highlighter
const CodeBlock = ({ className, children }: any) => {
  const language = className ? className.replace('language-', '') : '';
  return (
    <pre className={`codeblock ${language}`}>
      <code className={className}>{children}</code>
    </pre>
  );
};

interface MessageContentProps {
  content: string;
}

const MessageContent: React.FC<MessageContentProps> = ({ content }) => {
  // Function to replace figure tags with actual images
  const processContentWithImages = () => {
    // Check if content contains figure IDs
    if (!content.includes('[FIGURE_ID:')) {
      return (
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            code: CodeBlock,
            a: (props: any) => (
              <a target="_blank" rel="noopener noreferrer" {...props} />
            ),
          }}
        >
          {content}
        </ReactMarkdown>
      );
    }

    // Split content by figure tags
    const parts = content.split(/(\[FIGURE_ID:[a-z0-9-]+\])/gi);
    
    return (
      <>
        {parts.map((part, index) => {
          // Check if this part is a figure tag
          const match = part.match(/\[FIGURE_ID:([a-z0-9-]+)\]/i);
          
          if (match) {
            const imageId = match[1];
            const imageData = extractedImages.get(imageId);
            
            if (imageData) {
              return (
                <div key={index} className="figure-container">
                  <img 
                    src={imageData.dataUrl} 
                    alt={`Figure from page ${imageData.pageNumber}`} 
                    className="figure-image"
                  />
                </div>
              );
            }
            
            // If image not found, return the raw tag
            return <span key={index}>{part}</span>;
          }
          
          // Regular text content with enhanced markdown
          return (
            <ReactMarkdown
              key={index}
              remarkPlugins={[remarkGfm]}
              components={{
                code: CodeBlock,
                a: (props: any) => (
                  <a target="_blank" rel="noopener noreferrer" {...props} />
                ),
              }}
            >
              {part}
            </ReactMarkdown>
          );
        })}
      </>
    );
  };

  return (
    <div className="message-text markdown-content">
      {processContentWithImages()}
    </div>
  );
};

export default MessageContent; 